export function leerArchivoSinComprimir(file) {
  return new Promise((resolve, reject) => {
    const lector = new FileReader();
    lector.onerror = () => reject(new Error("No se pudo leer el archivo"));
    lector.onload = () => resolve(lector.result); // "data:image/...;base64,...."
    lector.readAsDataURL(file);
  });
}

export function comprimirImagen(file, { maxAncho = 1280, calidad = 0.7 } = {}) {
  return new Promise((resolve, reject) => {
    const lector = new FileReader();
    lector.onerror = () => reject(new Error("No se pudo leer el archivo"));
    lector.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("No se pudo procesar la imagen"));
      img.onload = () => {
        let { width, height } = img;
        if (width > maxAncho) {
          height = Math.round((height * maxAncho) / width);
          width = maxAncho;
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (!blob) { reject(new Error("No se pudo comprimir la imagen")); return; }
            resolve(blob); // Blob JPEG comprimido, listo para guardar/subir
          },
          "image/jpeg",
          calidad
        );
      };
      img.src = lector.result;
    };
    lector.readAsDataURL(file);
  });
}

// Blob -> base64 (para poder guardarlo en IndexedDB/Dexie — Dexie no
// guarda bien Blobs grandes de forma confiable en todos los navegadores,
// así que se guarda como string base64).
export function blobABase64(blob) {
  return new Promise((resolve, reject) => {
    const lector = new FileReader();
    lector.onerror = () => reject(new Error("No se pudo convertir la imagen"));
    lector.onload = () => resolve(lector.result); // "data:image/jpeg;base64,...."
    lector.readAsDataURL(blob);
  });
}

// base64 -> Blob (para poder subirlo con FormData al sincronizar)
export function base64ABlob(base64) {
  const [meta, datos] = base64.split(",");
  const mime = meta.match(/:(.*?);/)[1];
  const binario = atob(datos);
  const bytes = new Uint8Array(binario.length);
  for (let i = 0; i < binario.length; i++) bytes[i] = binario.charCodeAt(i);
  return new Blob([bytes], { type: mime });
}